import { createFileRoute } from "@tanstack/react-router";

import { AppearanceSettingsPanel } from "../components/settings/AppearanceSettingsPanel";

function SettingsAppearanceRouteView() {
  return <AppearanceSettingsPanel />;
}

export const Route = createFileRoute("/_app/settings/")({
  component: SettingsAppearanceRouteView,
});
